import bgBanner from '@/assets/images/home_bg.png';
// images import
import logoBlack from '../../assets/images/logo.png';
import logoWhite from "../../assets/images/logo_w.png";
import { db } from './firebase';

export default {
    state: {
        products: [],
        categories: [],
        categoryNow: "McCwG9uaNqQIIY5HqlgL",
        locales: "name_EN",
        // static images
        Images: {
            Logo: {
                logoBlack: logoBlack,
                logoWhite: logoWhite,
            },
            Home: {
                header: {
                    icon: require("@/assets/images/icon_Lang.svg"),
                },
                banner: {
                    bg: bgBanner,
                },
                icon: {
                    McCwG9uaNqQIIY5HqlgL: require("@/assets/images/icon_screw.svg"),
                    "4ukfSmNyu5egpbeW8Foh": require("@/assets/images/icon_nail.svg"),
                    E6xxLD026ormxXqfBZiu: require("@/assets/images/icon_nail.svg"),
                    TgfEv73Rt9rqmZKiJx7R: require("@/assets/images/icon_nail.svg"),
                    gbei2OTYevrQBYHPTtF6: require("@/assets/images/icon_nail.svg"),
                    sIoawm66nlESf7TbjkpW: require("@/assets/images/icon_nail.svg"),
                    zt2LiVKzQGzNzYjBH0t0: require("@/assets/images/icon_nail.svg"),
                    AllProduct: require("../../assets/images/icon__All.svg"),
                },
                Search: {
                    search: require("../../assets/images/search-24px.svg"),
                    download: require("../../assets/images/get_app-white-18dp.svg"),
                    cancel: require("../../assets/images/clear-24px.svg"),
                },
                exhibition: {
                    icons: require("@/assets/images/icon_Arrow.svg"),
                },
                about: {
                    bg: require("../../assets/images/bg_home_search.png"),
                    arrow: require("../../assets/images/arrow_forward-white-18dp.svg"),
                },
            },
            Products: {},
            Manufacture: {
                A: require("../../assets/images/Manu_A_.jpg"),
                // B: require("../../assets/images/Manu_B_.jpg"),
                C: require("../../assets/images/Manu_C_.jpg"),
                D: require("../../assets/images/Manu_D_.jpg"),
                E: require("../../assets/images/Manu_E_.jpg"),
                F: require("../../assets/images/Manu_F_.jpg"),
                G: require("../../assets/images/Manu_G_.jpg"),
                I: require("../../assets/images/Manu_I_.jpg"),
                J: require("../../assets/images/Manu_J_.jpg"),
                K: require("../../assets/images/Manu_K_.jpg"),
                L: require("../../assets/images/Manu_L_.jpg"),
                M: require("../../assets/images/Manu_M_.jpg"),
                // N: require("../../assets/images/Manu_N_.jpg"),
                O: require("../../assets/images/Manu_O_.jpg"),
                P: require("../../assets/images/Manu_P_.jpg"),
                Q: require("../../assets/images/Manu_Q_.png"),
            },
            Quality: {
                banner: require("@/assets/images/bg_qf_quality.png"),
                cf: {
                    "01": require("@/assets/images/certificate_01@2x.png"),
                    "02": require("@/assets/images/certificate_02@2x.png"),
                    "03": require("@/assets/images/certificate_03@2x.png"),
                    "04": require("@/assets/images/certificate_04@2x.png"),
                    "05": require("@/assets/images/certificate_05@2x.png"),
                },
                eq: {
                    "01": require("@/assets/images/equipment-01@2x.png"),
                    "02": require("@/assets/images/equipment-02@2x.png"),
                    "03": require("@/assets/images/equipment-03@2x.png"),
                    "04": require("@/assets/images/equipment-04@2x.png"),
                    "05": require("@/assets/images/equipment-05@2x.png"),
                    "06": require("@/assets/images/equipment-06@2x.png"),
                    "07": require("@/assets/images/equipment-07@2x.png"),
                    "08": require("@/assets/images/equipment-08@2x.png"),
                    "09": require("@/assets/images/equipment-09@2x.jpg"),
                    "10": require("@/assets/images/equipment-10@2x.jpg"),
                },
            },
            Comp: {
                Product: {},
                Contact: {
                    bg: require("@/assets/images/thumbs_about_history.png"),
                },
                Language: {},
            },
            Mobile: {
                nav: {
                    home: require("../../assets/images/icon_home.svg"),
                    product: require("../../assets/images/icon__screw.svg"),
                    quality: require("../../assets/images/icon_quality.svg"),
                    contact: require("../../assets/images/icon_email.svg"),
                },
                search: {
                    switch: require("../../assets/images/import_export-white-18dp.svg"),
                },
            },
        },
        News: null,
        newsCategories: null,
        Videos: null,
        windowWidth: 0,
    },
    mutations: {
        fetchProducts: (state) => {
            state.products = [];
            // 重置產品資料
            db.collection("Products")
                .get()
                .then((rsv) => {
                    rsv.forEach((doc) => {
                        state.products.push({ id: doc.id, ...doc.data() });
                    });
                })
                .catch((err) => {
                    console.log(err);
                });
            db.collection("Categories")
                .get()
                .then((rsv) => {
                    state.categories = [];
                    rsv.forEach((cata) => {
                        state.categories.push({
                            id: cata.id,
                            name: cata.data(),
                        });
                    });
                })
                .catch((err) => {
                    console.log(err);
                });
            db.collection("News")
                .get()
                .then((rsv) => {
                    const newArr = rsv.docs.map((doc) => {
                        const newDoc = doc.data();
                        newDoc.date = new Date(newDoc.date);
                        return newDoc;
                    });
                    state.News = newArr;
                })
                .catch((err) => {
                    console.log(err);
                });
            db.collection("Videos")
                .where("isShow", "==", true)
                .get()
                .then((rsv) => {
                    const newVideo = rsv.docs.map((doc) => {
                        const newDoc = doc.data();
                        return newDoc;
                    });
                    state.Videos = [...newVideo];
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        saveNewsCategories: (state, payload) => {
            const cata = payload.filter((i) => i.status);
            state.newsCategories = cata.sort((a, b) => (b.isFirst ? 1 : -1));
        },
        stateLocale: (state, { LANG }) => {
            console.log(LANG);
            state.locales = LANG;
        },
        switchCategory(state, change) {
            state.categoryNow = change.id;
        },
        setWidth(state, Width) {
            state.windowWidth = Width;
        },
    },
    actions: {
        fetchProduct: ({ commit }) => {
            commit("fetchProducts");
        },
        changeCategory: ({ commit }, payload) => {
            commit("switchCategory", payload);
        },
        localeChange: ({ commit }, payload) => {
            commit("stateLocale", payload);
        },
        getWindowW({ commit }) {
            const Width = window.innerWidth;
            commit("setWidth", Width);
        },
        async fetchNewsCategories({ commit }) {
            const res = await db.collection("NewsCategories").get();
            const data = res.docs.map((e) => ({ id: e.id, ...e.data() }));
            commit("saveNewsCategories", data);
        },
    },
    getters: {
        CataNowList(state) {
            const sortArr = state.categories.sort(
                (a, b) => a.name.order - b.name.order
            );

            return sortArr.reduce(
                (ac, el) => {
                    return { ...ac, [el.id]: { id: el.id, ...el.name } };
                },
                {
                    AllProduct: {
                        id: "AllProduct",
                        bannerPath: state.Images.Home.banner.bg,
                        iconPath: state.Images.Home.icon.AllProduct,
                        name_CH: "全部產品",
                        name_EN: "All Products",
                        order: 0,
                    },
                }
            );
        },
        Mobile(state) {
            return state.windowWidth < 440 ? true : false;
        },
    },
};

